import * as React from "react";
import {
  File as FileIcon,
  Command,
  BookText,
  House,
  ClipboardMinus,
  Users,
  Stamp,
  Book,
  Blocks,
  List,
  HandCoins,
  Palmtree,
  Briefcase,
  MessageCircle,
  LayoutTemplate,
} from "lucide-react";
import { useHasAccess } from "./AccessGuard";
import { NavContacts } from "@/components/nav-contacts";
import { NavMain } from "@/components/nav-main";
import { NavUser } from "@/components/nav-user";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarRail,
} from "@/components/sidebar";
import { TeamSwitcher } from "@/components/team-switcher";

// This is sample data.
const data = {
  navMain: [
    {
      title: "Dashboard",
      url: "dashboard",
      icon: House,
    },
    // {
    //   title: "Mass-reporting",
    //   url: "reports",
    //   icon: ClipboardMinus,
    //   disabled: true,
    // },
    {
      title: "Ledger",
      url: "ledger",
      icon: Blocks,
    },
    {
      title: "Prospects",
      url: "prospects",
      icon: Command,
    },
    {
      title: "Instruments",
      url: "securities",
      icon: BookText,
    },
    {
      title: "Model Portfolios",
      url: "modelportfolios",
      icon: LayoutTemplate,
    },
    {
      title: "Contacts",
      url: "contacts",
      icon: Users,
    },
    {
      title: "Portfolios",
      url: "portfolios",
      icon: Briefcase,
    },
    // {
    //   title: "Quality Control",
    //   url: "quality",
    //   icon: Stamp,
    // },
    {
      title: "Offer",
      url: "offer",
      icon: HandCoins,
    },
    {
      title: "Documents",
      url: "documents",
      icon: FileIcon,
    },
    {
      title: "Positions",
      url: "positions",
      icon: Book,
    },
    {
      title: "Transactions",
      url: "transactions",
      icon: List,
    },
    {
      title: "Leave Calendar",
      url: "holiday",
      icon: Palmtree,
    },
  ],
};

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  const roles = ["ROLE_FA_ADMIN"];
  const users = [
    "inv06098142981",
    "cap06098142981",
    "inv10088337722",
    "cap10088337722",
    "inv04117738707",
    "cap04117738707",
  ];
  const hasAccess = useHasAccess({
    rolesIncluded: roles,
    usersIncluded: users,
  });

  const menuItems = [
    ...data.navMain,
    ...(hasAccess
      ? [{ title: "Trader", url: "trader", icon: MessageCircle }]
      : []),
  ];

  return (
    <Sidebar collapsible="icon" {...props}>
      <SidebarHeader>
        <TeamSwitcher />
      </SidebarHeader>
      <SidebarContent className="gap-1">
        <NavMain items={menuItems} />
        <NavContacts />
      </SidebarContent>
      <SidebarFooter>
        <NavUser />
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  );
}
